import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { VideoPageType } from '../../constants/videoPage';
import { ResourceLibrary } from '../../containers/ResourceLibrary/ResourceLibrary';

type NgzResourceLibraryProps = {
  page: VideoPageType;
};

const NgzResourceLibrary = ({ page }: NgzResourceLibraryProps) => {
  return (
    <Container>
      <ResourceLibrary page={page} />
    </Container>
  );
};

angularizeWithProviders(NgzResourceLibrary, 'ngzResourceLibrary', { page: '@' });
